import { useState } from "react";
import { TransparantIcon, NextButton } from "./../Button/IconButton";
import "./Input.css";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

export const TextInput = (props) => {
  return (
    <div className="mt-3 d-flex flex-column input-container">
      <input
        className={`input-text-container p-2 ${
          props.className ? props.className : ""
        }`}
        {...props}
      ></input>
      <span className="form-text text-danger">{props.error || ""}</span>
    </div>
  );
};

export const PasswordInput = (props) => {
  const [closedPassword, setclosedPassword] = useState(true);

  return (
    <div className="position-relative mt-3 d-flex flex-column">
      <div>
        <div className="col-12 position-relative">
        <input
          className={`input-text-container p-2 pe-5 ${
            props.className ? props.className : ""
          }`}
          type={closedPassword ? "password" : "text"}
          {...props}
        ></input>
        <TransparantIcon
          className={`position-absolute ${props.infoIcon?"info-eye-icon":"eye-icon"}`}
          onClick={() => setclosedPassword(!closedPassword)}
        >
          {closedPassword ? (
            <img src="/icons/eyeicon.svg" alt="eye"></img>
          ) : (
            <img src="/icons/eyeclosed.svg" alt="eye"></img>
          )}
        </TransparantIcon>
        {
            props.infoIcon &&
            (
            <div className="px-2 position-absolute info-icon-position">
                <Tippy content={<span>Your Password must contain at least: 6 characters, 1 lower case letter, 1 upper case letter, 1 number and 1 special character</span>}>
                  <img src="/icons/info-icon.svg" alt="info"></img>
                </Tippy>
            </div>
        )}
        </div>
        
      </div>
      <span className="form-text text-danger">{props.error || ""}</span>
    </div>
  );
};

export const YellowTextBox = ({
  placeholder,
  id,
  name,
  className,
  onChange,
  value,
  textType,
  maxLength
}) => {
  return (
    <input
      placeholder={placeholder}
      className={`comment-box-container p-3 ${className ? className : ""} ${
        textType === "comment"
          ? "comment-text-box"
          : textType === "editComment"
          ? "edit-comment"
          : "sponsor-id-box"
      }`}
      type="text"
      id={id}
      name={name}
      onChange={onChange}
      value={value}
      maxLength={maxLength}
    ></input>
  );
};

export const YellowTextArea = ({
  placeholder,
  id,
  name,
  className,
  onChange,
  value,
}) => {
  return (
    <textarea
      placeholder={placeholder}
      className={`comment-box-container p-3 ${
        className ? className : ""
      } edit-comment`}
      type="text"
      id={id}
      name={name}
      onChange={onChange}
      value={value}
    ></textarea>
  );
};

export const SearchBox = ({
  placeholder,
  id,
  name,
  className,
  onChange,
  value,
  searchReference,
  clearSearch
}) => {
  return (
    <div className="position-relative">
      <input
        placeholder={placeholder}
        className={`input-text-container search-box p-2 ${
          className ? className : ""
        }`}
        type="text"
        id={id}
        name={name}
        onChange={onChange}
        value={value}
        ref={searchReference}
      ></input>
      <div className="position-absolute search-icon">
        {
          value?(
            <img src="/icons/brown-cross.svg" alt="search" style={{height:"20px", width:"20px", cursor:"pointer"}} onClick={clearSearch}></img>
          ):(
            <img src="/icons/search-icon.svg" alt="search"></img>
          )
        }
      </div>
    </div>
  );
};

export const EnterBookingId = ({
  placeholder,
  id,
  name,
  className,
  onChange,
  value,
  onClickHandler,
  isLoading,
  disabledButton,
  fomikButton,
  clearSearch
}) => {
  return (
    <div className="position-relative">
      <input
        placeholder={placeholder}
        className={`input-text-container enter-box ${
          className ? className : ""
        }`}
        type="text"
        id={id}
        name={name}
        onChange={onChange}
        value={value}
      ></input>
      <div className="position-absolute search-icon-booking">
        {
          value && (
            <img src="/icons/brown-cross.svg" alt="search" style={{height:"20px", width:"20px", cursor:"pointer"}} onClick={clearSearch}></img>
          )
        }
      </div>
      <div className="position-absolute enter-button">
        <NextButton
          onClick={onClickHandler}
          isLoading={isLoading}
          disabled={disabledButton}
          formik={fomikButton}
        ></NextButton>
      </div>
    </div>
  );
};
